import { RiFileExcel2Line, RiImageAddLine } from "react-icons/ri"
import Excel from "./zoneExcel"
import BarcodeUploadTab from "./importPhoto/BarcodeUploadTab"

function ImportArea() {

  return (
    <>
      <div className="text-center">
        <div className="max-w-6xl mx-auto px-4 mt-8 mb-5 flex flex-col items-center gap-2 md:grid md:grid-cols-3 md:items-center">
          <span className="hidden md:block" aria-hidden="true" />
          <h1 className="text-2xl font-bold text-gray-800 md:text-center">อัปโหลดรูปภาพ EA</h1>
          <ul
            className="inline-flex items-center gap-0.5 rounded-full border border-gray-200 bg-gray-50 p-0.5 list-none md:justify-self-end"
            role="tablist"
            data-te-nav-ref>
          <li role="presentation">
            <a
              href="#tabs-photo"
              className="group inline-flex items-center justify-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium uppercase leading-tight text-neutral-500 transition-colors hover:bg-neutral-100 data-[te-nav-active]:bg-blue-100 data-[te-nav-active]:text-blue-700"
              data-te-toggle="pill"
              data-te-target="#tabs-photo"
              data-te-nav-active
              role="tab"
              aria-controls="tabs-photo"
              aria-selected="true"
              >
                <RiImageAddLine size={16} />
                <span className="hidden group-data-[te-nav-active]:inline">Import Photo</span>
            </a>
          </li>
          <li role="presentation">
            <a
              href="#tabs-excel"
              className="group inline-flex items-center justify-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium uppercase leading-tight text-neutral-500 transition-colors hover:bg-neutral-100 data-[te-nav-active]:bg-emerald-100 data-[te-nav-active]:text-emerald-700"
              data-te-toggle="pill"
              data-te-target="#tabs-excel"
              role="tab"
              aria-controls="tabs-excel"
              aria-selected="false"
              >
                <RiFileExcel2Line size={16} />
                <span className="hidden group-data-[te-nav-active]:inline">Import Excel</span>
            </a>
          </li>
          </ul>
        </div>
        <div className="mb-6">
          <div
            className="hidden opacity-0 opacity-100 transition-opacity duration-150 ease-linear data-[te-tab-active]:block"
            id="tabs-photo"
            role="tabpanel"
            aria-labelledby="tabs-photo-tab"
            data-te-tab-active>
            <BarcodeUploadTab />
          </div>
          <div
            className="hidden opacity-0 transition-opacity duration-150 ease-linear data-[te-tab-active]:block"
            id="tabs-excel"
            role="tabpanel"
            aria-labelledby="tabs-excel-tab">
            <Excel />
          </div>
        </div>
      </div>
    </>
  );
}

export default ImportArea;
